import { useEffect, useState } from "react";
import { http } from "@/lib/api";

const COLOR = { BUY: "var(--win)", SELL: "var(--loss)", ATTENDI: "var(--draw)" };
const STATUS = { open: "Aperto", closed: "Chiuso", renewed: "Rinnovato", wait: "—" };

export default function GoldHistory({ reload, asset = "XAU" }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { http.get("/gold/signals", { params: { asset } }).then((r) => setRows(r.data)); }, [reload, asset]);

  return (
    <div className="panel overflow-x-auto">
      <div className="px-5 pt-5 font-display text-2xl font-bold uppercase">Storico segnali</div>
      <table data-testid="gold-history-table" className="w-full text-sm mt-3">
        <thead>
          <tr className="text-slate-400 text-xs uppercase tracking-wider border-b border-slate-800">
            {["Data", "Segnale", "Prezzo", "Entrata", "SL", "TP1", "TP2", "Fiducia", "Esito"].map((h) => <th key={h} className="py-3 px-3 text-left font-semibold">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={9} className="py-6 px-3 text-slate-500">Nessun segnale ancora.</td></tr>}
          {rows.map((r) => (
            <tr key={r.id} data-testid="gold-history-row" className="border-b border-slate-800/60 font-mono">
              <td className="py-2 px-3 whitespace-nowrap">{new Date(r.created_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</td>
              <td className="py-2 px-3 font-bold" style={{ color: COLOR[r.data.segnale] }}>{r.data.segnale}</td>
              {[r.price, r.data.entrata, r.data.stop_loss, r.data.take_profit_1, r.data.take_profit_2].map((v, i) => <td key={i} className="py-2 px-3">{v ?? "—"}</td>)}
              <td className="py-2 px-3">{r.data.fiducia}%</td>
              <td className="py-2 px-3 whitespace-nowrap">{(r.hits || []).map((h) => h.toUpperCase()).join(" · ") || STATUS[r.status]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
